"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdaptableOptionsWizardView = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const agGrid_1 = require("@adaptabletools/adaptable/agGrid");
const AdaptableReact_1 = tslib_1.__importDefault(require("./AdaptableReact"));
const AdaptableOptionsWizardView = (props) => {
    const { shouldRenderAdaptable, adaptableProps } = props, adaptableWizardViewProps = tslib_1.__rest(props, ["shouldRenderAdaptable", "adaptableProps"]);
    const [adaptableConfig, setAdaptableConfig] = React.useState(null);
    if (!adaptableConfig) {
        return (React.createElement(agGrid_1.AdaptableWizardView, Object.assign({}, adaptableWizardViewProps, { onInit: (adaptableOptions, gridOptions) => {
                setAdaptableConfig({ adaptableOptions, gridOptions });
                props === null || props === void 0 ? void 0 : props.onInit(adaptableOptions, gridOptions);
            } })));
    }
    if (adaptableConfig && props.shouldRenderAdaptable) {
        const preparedAdaptableProps = Object.assign(Object.assign({}, adaptableProps), { adaptableOptions: adaptableConfig.adaptableOptions, gridOptions: adaptableConfig.gridOptions });
        return React.createElement(AdaptableReact_1.default, Object.assign({}, preparedAdaptableProps));
    }
    return React.createElement(React.Fragment, null);
};
exports.AdaptableOptionsWizardView = AdaptableOptionsWizardView;
